//
// Copyright 2026 DXOS.org
//
import * as Schema from 'effect/Schema';
/**
 * Longest `payload` EDGE accepts on `POST /inbox/:recipientDid`; a sender checks it before sending.
 */
export const INBOX_MAX_PAYLOAD_LENGTH = 16 * 1024;
/**
 * Body of `POST /inbox/:recipientDid`.
 * The sender is taken from the verified presentation, never from the body.
 */
export const InboxSendRequestSchema = Schema.Struct({
    /** Opaque to EDGE: base64 of a binary-encoded `dxos.halo.inbox.InboxEnvelope` (legacy: a signed `Credential`). */
    payload: Schema.String,
});
export const InboxSendResponseSchema = Schema.Struct({
    id: Schema.String,
});
/**
 * A pending notice as EDGE stores and returns it.
 */
export const InboxNoticeSchema = Schema.Struct({
    /** Assigned by EDGE; the handle passed to `POST /inbox/ack`. */
    id: Schema.String,
    /** Identity DID of the authenticated sender. */
    senderDid: Schema.String,
    /** Epoch milliseconds. */
    sentAt: Schema.Number,
    /** Epoch milliseconds. */
    expiresAt: Schema.Number,
    payload: Schema.String,
});
/**
 * Response of `GET /inbox`: the caller's own pending notices.
 */
export const InboxListResponseSchema = Schema.Struct({
    notices: Schema.Array(InboxNoticeSchema),
});
/**
 * Body of `POST /inbox/ack`: removes the notices for every device of the caller's identity.
 */
export const InboxAckRequestSchema = Schema.Struct({
    ids: Schema.Array(Schema.String),
});
//# sourceMappingURL=inbox.js.map